import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Breadcrumb } from "react-bootstrap";
import { COLOR_APP } from "../../constants";

function HelpBeginner() {
    const { history } = useReactRouter()


    useEffect(() => {

    }, [])


    return (
        <div>
            <div style={{ height: 30 }} />
            <p>ການໃຊ້ງານເບື້ອງຕົ້ນ</p>
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/y9TXniMTjJ8" title="ການໃຊ້ງານເບື້ອງຕົ້ນ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <div style={{ height: 20 }} />
            <p>ການເພີ່ມສິນຄ້າເຂົ້າໃນລະບົບ</p>
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/DM3EgHBqHHo" title="ການເພີ່ມສິນຄ້າເຂົ້າໃນລະບົບ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            <div style={{ height: 20 }} />
            <p>ອະທິບາຍພາບລວມຂອງຫນ້າສະຖິຕິ</p>
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/t48G6Tme630" title="ອະທິບາຍພາບລວມຂອງຫນ້າສະຖິຕິ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            <div style={{ height: 20 }} />
            <p>ວິທີເຂົ້າສູ່ລະບົບ</p>
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/LrwPL3K99Ww" title="ວິທີເຂົ້າສູ່ລະບົບ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div >
    );
}

export default HelpBeginner;